import { render, staticRenderFns } from "./Talk.vue?vue&type=template&id=e13cb6fe&scoped=true"
import script from "./Talk.vue?vue&type=script&lang=js"
export * from "./Talk.vue?vue&type=script&lang=js"
import style0 from "./Talk.vue?vue&type=style&index=0&id=e13cb6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13cb6fe",
  null
  
)

export default component.exports